export default {
      id: "link-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#link",
      toString: function () {
        return this.url;
      }
    }